export const resetPasswordES = {
  main: 'Actualice su nueva contraseña'
}
